import { IGetAllFuncionariosAprovadoresUseCase } from "../../../presentation/useCases/read/get_all_funcionarios_aprovadores_use_case";
import { FuncionarioAprovador } from "../../models/funcionario_aprovador";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetAllFuncionariosAprovadoresUseCase
 */

export class GetAllFuncionariosAprovadoresUseCase implements IGetAllFuncionariosAprovadoresUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getAllFuncionariosAprovadores(
    nomeEmailFuncionario: string | null,
    centrosCusto: number[] | null,
  ): Promise<FuncionarioAprovador[]> {
    return await this.repository.getAllFuncionariosAprovadores(
      nomeEmailFuncionario,
      centrosCusto,
    );
  }
}
